import { VERTICAL_ASPECT_STRING } from '../../aspects';
import { TemplatePage } from './types';

const youtubeShortsPage: TemplatePage = {
  header: {
    color: '#83DEF3',
    icon: 'images/video-templates/facebook-cover.jpg',
    title: 'YouTube Shorts Video Templates',
    title_meta: '50+ Free Facebook Cover Video Templates',
    description_meta:
      'Looking for easy-to-use and customizable video templates for your YouTube' +
      ' Shorts? Save time and create engaging Shorts videos in minutes!',
    description:
      'Create stunning YouTube Shorts that will captivate your audience and keep' +
      ' them coming back for more with our customizable video templates. Save time' +
      ' on making Shorts videos that stand out from the crowd.'
  },
  footer: {
    category: 'YouTube Shorts',
    description:
      'Wave.video has an extensive collection of pre-made YouTube Shorts video templates' +
      ' that can be customized to match your brand and message. Created by professional' +
      ' designers, our templates empower you to create a visually striking YouTube Shorts' +
      ' video within minutes. The intuitive drag-and-drop editor allows you to effortlessly' +
      ' add your own footage, text, and music, making it easy to create a captivating' +
      ' YouTube Shorts video.'
  },
  content: [
    {
      type: 'templates',
      title: 'YouTube Shorts templates',
      search: {aspects: VERTICAL_ASPECT_STRING }
    },
    {
      type: 'stocks',
      title: 'youtube shorts',
      search: { name: 'youtube shorts' }
    },
    { type: 'calendar' }
  ]
};

export default youtubeShortsPage;
